import { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus } from 'lucide-react';

interface AdminPageHeaderProps {
  title: string;
  count?: number;
  onAdd?: () => void;
  addLabel?: string;
  actions?: ReactNode;
}

export function AdminPageHeader({ 
  title, 
  count, 
  onAdd, 
  addLabel = 'Add New',
  actions 
}: AdminPageHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        <h2 className="text-xl font-semibold">{title}</h2>
        {count !== undefined && (
          <Badge variant="secondary" className="text-xs">
            {count}
          </Badge>
        )}
      </div>
      <div className="flex items-center gap-2">
        {actions}
        {onAdd && (
          <Button onClick={onAdd}>
            <Plus className="h-4 w-4 mr-2" />
            {addLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
